<template>
  <div class="product-comments-card" v-if="!answer || (answer && (!showAllAnswers ? answerKey === 0 : true) && !isShort) || (isShort && showAllAnswers)" :class="{'product-comments-card--answer': answer, 'product-comments-card--short': isShort, 'product-comments-card--padding': catalogPage, 'product-comments-card--comment-modal': isCommentModal}">
    <header class="product-comments-card__header comment-card-header">
      <img v-if="!catalogPage"
           class="comment-card-header__avatar"
           :src="avatar"
           alt="avatar" />
      <div class="comment-card-header__info-wrap" :class="{'comment-card-header__info-wrap--without-margin': catalogPage}">
        <div class="comment-card-header__name-wrap">
          <a v-if="productName" class="comment-card-header__name" :href="productLink">{{ productName }}</a>
          <span v-else class="comment-card-header__name _text-cap">{{ name }}</span>
          <span
            v-if="label && labelType"
            class="comment-card-header__label"
            :class="{'comment-card-header__label--bought': labelType === 'bought', 'comment-card-header__label--campaign': labelType === 'campaign'}"
          >
            <svg v-if="labelType === 'bought'"
                 width="16"
                 height="16"
                 fill="none">
              <use :xlink:href="spritePath + '#buy-cart'"></use>
            </svg>
            <span class="comment-card-header__label-text block-ellipsis block-ellipsis-truncate">
              {{ label }}
            </span>
          </span>
        </div>
        <div class="comment-card-header__info" :class="{'comment-card-header__info--questions': isQuestions}">
          <div class="comment-form__tags" v-if="isQuestions && tags.length">
            <div v-for="tag in tags" :key="tag.id" class="comment-form__tag active">
              <span class="comment-form__tag-title">{{ tag.title }}</span>
            </div>
          </div>
          <StarRating v-if="!answer && rate > 0 && !isQuestions"
                      :value="+rate"
                      :disabled="true"
                      class="comment-card-header__rating"
                      :title="Number(rate).toFixed(1)"
                      size="medium" />
          <span class="comment-card-header__date">
            {{ date }}
          </span>
        </div>
      </div>
    </header>
    <div class="product-comments-card__comment-wrap" :class="{'product-comments-card__comment-wrap--fixed-height': catalogPage}">
      <p class="product-comments-card__from-set" v-if="isMoved && productInfo.productId !== +movedFrom.id">
        {{$t('from_set')}}:
        <a v-if="movedFrom.link" :href="movedFrom.link" class="link">{{ movedFrom.name }}</a>
        <span v-else>{{ movedFrom.name }}</span>
      </p>
      <span class="product-comments-card__comment" :class="{'product-comments-card__comment--fixed-height': catalogPage}" v-html="formattedComment"></span>
      <div class="product-comments-card__block" v-if="!catalogPage && reasonForPurchase && !answer && !isShort">
        <span class="product-comments-card__block-title">{{ $t('review.reason.for.purchase') }}:</span>
        <span class="product-comments-card__comment" v-html="formattedReasonForPurchase"></span>
      </div>
      <div v-if="this.isTranslatedComment" class="product-comments-card__translate-actions">
        <div class="product-comments-card__translate-status">
          <img src="/img/svgo/chat-check.svg" alt="">
          <span>{{ $t('comment_translation_status') }}</span>
        </div>
        <div class="product-comments-card__translate-trigger" @click="commentTranslationChange">
          <span v-if="!showOriginalComment">{{ $t('comment_translation_show_original') }}</span>
          <span v-if="showOriginalComment">{{ $t('comment_translation_show_translate') }}</span>
        </div>
      </div>
      <div class="product-comments-card__block" v-if="!catalogPage && !answer && photosForRender && !isShort && !isCommentModal">
        <ul class="product-comments-card__photo-list">
          <li
            class="product-comments-card__photo-item"
            :class="{'photo-product-comments-card__photo-item--video': item.video_id }"
            v-for="(item, i) in photosForRender"
            :key="i"
            @click="openCommentPhotoModal(item.video_id ? item.video_id : item.origin_photo)"
          >
            <div
              v-if="item.video_id"
              :style="{backgroundImage: `url(https://img.youtube.com/vi/${item.video_id}/sddefault.jpg)`}"
              class="swiper-lazy video-item__img"></div>
            <div v-if="item.video_id" class="play-video-btn"></div>
            <img
              v-else
              class="product-comments-card__thumb-img"
              :src="item.thumb_photo"
              :alt="'фото-' + i + 1"
            />
          </li>
          <li
            @click="openCommentPhotoModal(photosForRender[0].video_id ? photosForRender[0].video_id : photosForRender[0].origin_photo)"
            v-if="media.length > countPhotosForView"
            class="product-comments-card__photo-item"
          >
            <span>Еще: {{ media.length - countPhotosForView }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="!answer && !catalogPage" class="product-comments-card__actions" :class="{'product-comments-card__actions--fixed-height': catalogPage}">
      <button @click="auth ? showAnswerForm(id) : openAuthModal()" class="product-comments-card__btn">{{ $t('comment.answer.button') }}</button>
      <button v-if="isShort && isAnswers && !hideBtn" class="product-comments-card__btn" @click="showAnswers(id)">{{ answerBtn }}</button>
      <span v-else-if="!isShort" class="product-comments-card__count-text">{{ answerBtn }}</span>
    </div>
  </div>
</template>

<script>
import { spritePath } from '@/mixins/spritePath'
import { mapGetters, mapState } from 'vuex'
import StarRating from '@/components/product/StarRating'

export default {
  name: 'CommentCard',
  mixins: [spritePath],
  components: {
    StarRating
  },
  data () {
    return {
      countPhotosForView: 3,
      showOriginalComment: false
    }
  },
  props: {
    isQuestions: {
      type: Boolean,
      default: false
    },
    isShort: {
      type: Boolean,
      default: false
    },
    isAnswers: {
      type: Boolean,
      default: false
    },
    isTranslatedComment: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelType: {
      type: String,
      default: ''
    },
    answer: {
      type: Boolean,
      default: false
    },
    avatar: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    rate: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    comment: {
      type: String,
      default: ''
    },
    translatedComment: {
      type: String,
      default: ''
    },
    reasonForPurchase: {
      type: String,
      default: ''
    },
    translatedReasonForPurchase: {
      type: String,
      default: ''
    },
    answerBtn: {
      type: String,
      default: ''
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    showAllAnswers: {
      type: Boolean,
      default: false
    },
    answerKey: {
      type: Number,
      default: 0
    },
    isMoved: Boolean,
    isCommentModal: Boolean,
    movedFrom: Object,
    catalogPage: Boolean,
    productName: String,
    productLink: String,
    media: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    endpoint: {
      type: String,
      required: true
    },
    productId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      auth: state => state.user.auth,
      productInfo: state => state.productInfo.productInfo
    }),
    photosForRender () {
      return this.media.slice(0, this.countPhotosForView)
    },
    formattedComment () {
      let comment
      if (this.isTranslatedComment) {
        comment = this.textFormatter(this.translatedComment || '')
      } else {
        comment = this.textFormatter(this.comment || '')
      }
      if (this.showOriginalComment) {
        return this.textFormatter(this.comment || '')
      }
      return comment
    },
    formattedReasonForPurchase () {
      let reason
      if (this.isTranslatedComment) {
        reason = this.textFormatter(this.translatedReasonForPurchase || '')
      } else {
        reason = this.textFormatter(this.reasonForPurchase || '')
      }
      if (this.showOriginalComment) {
        return this.textFormatter(this.reasonForPurchase || '')
      }
      return reason
    }
  },
  methods: {
    commentTranslationChange () {
      this.showOriginalComment = !this.showOriginalComment
    },
    openCommentPhotoModal (data) {
      this.$modal.show('comment-photo-modal', {
        data: data,
        endpoint: this.endpoint,
        productId: this.productId,
        isQuestions: this.isQuestions
      })
    },
    showAnswerForm (id) {
      this.$emit('showAnswerForm', id)
    },
    showAnswers (id) {
      this.$emit('showAnswers', id)
    },
    textFormatter (text) {
      return text.replace(/(\\r)*\\n/g, '<br>')
    },
    openAuthModal () {
      this.$modal.show('auth-modal', {
        title: this.$t('comments_add_answer_auth_title')
      })
    }
  }
}
</script>

<style scoped lang="sass">
.comment-form
  &__tag
    font-size: 13px
    font-weight: 400
    line-height: 16px
    padding: 7px 15px
    color: #3E77AA
    margin: 0 10px 10px 0
    border: 1px solid rgba(#3E77AA, 0.5)
    border-radius: 5px
    &.active
      background-color: rgba(#3E77AA, 0.1)
      border-color: transparent

  &__tags
    display: flex
    flex-wrap: wrap
    margin-bottom: -10px
    +mmax($tablet)
      margin-left: -60px

.product-comments-card
  display: block
  width: 100%
  padding: 30px 0

  &--padding
    padding: 20px 30px
    width: auto

  &--comment-modal
    padding: 0 0 30px

  &__translate
    &-trigger
      font-size: 14px
      font-weight: 400
      line-height: 18px
      text-align: left
      color: #3E77AA
      border-bottom: 1px dashed #3E77AA
      cursor: pointer
      +mmax($large)
        order: -1
        margin-bottom: 10px
      &:hover
        border-bottom-color: transparent

    &-status
      display: flex
      font-size: 14px
      font-weight: 400
      line-height: 18px
      text-align: left
      color: #909090
      margin-right: 20px
      img
        width: 18px
        margin-right: 10px

    &-actions
      display: flex
      align-items: center
      margin-top: 15px
      +mmax($large)
        flex-direction: column
        align-items: flex-start

.product-comments-card--short
  padding: 0 0 30px

.product-comments-card__header
  display: flex
  flex-direction: row
  align-items: flex-start

  +mmin($tablet)
    align-items: center

.comment-card-header__avatar
  display: block
  border-radius: 50%
  width: 40px
  height: 40px
  object-fit: cover

.comment-card-header__info-wrap
  display: flex
  flex-direction: column
  margin-left: 20px
  width: 100%

  &--without-margin
    margin-left: 0

.comment-card-header__name-wrap
  display: flex
  flex-flow: column
  margin-bottom: 10px

  +mmin($tablet)
    align-items: center
    flex-flow: row wrap

.comment-card-header__label
  max-width: max-content
  display: flex
  flex-flow: row nowrap
  align-items: center
  padding: 8px 17px
  border-radius: 5px
  background: rgba(53, 157, 63, 0.1)
  color: #359D3F
  font-size: 13px
  margin-top: 10px

  +mmin($tablet)
    margin-top: 0

  svg
    flex-shrink: 0
    fill: #359D3F
    margin-right: 10px

  &--bought
    background: rgba(53, 157, 63, 0.1)
    color: #359D3F

  &--campaign
    background: rgba(62, 119, 170, 0.1)
    color: #3E77AA

.comment-card-header__label-text
  max-height: 14px
  word-break: break-all
  -webkit-box-orient: vertical
  -webkit-line-clamp: 1

.comment-card-header__name
  display: block
  color: #3e3e3e
  font-size: 16px
  font-weight: 500
  margin-right: 20px

.comment-card-header__info
  display: flex
  justify-content: space-between
  align-items: center
  width: 100%
  &--questions
    +mmax($tablet)
      flex-direction: column
      align-items: flex-start
      .comment-card-header__date
        order: -1
        margin-bottom: 15px

.comment-card-header__date
  font-size: 14px
  color: $placeholder-color

.product-comments-card__comment-wrap
  position: relative
  margin-top: 20px

  &:not(.product-comments-card__comment-wrap--fixed-height)
    +mmin($tablet--hor)
      margin-left: 60px
      max-width: 700px

  &--fixed-height
    height: 104px
    overflow: hidden

.product-comments-card__actions
  &:not(.product-comments-card__actions--fixed-height)
    +mmin($tablet--hor)
      margin-left: 60px
      max-width: 700px

.product-comments-card__comment
  font-size: 14px
  line-height: 150%
  max-width: 100%
  display: block
  word-break: break-word
  overflow: hidden

  &--fixed-height
    display: -webkit-box
    overflow: hidden
    text-overflow: ellipsis
    -webkit-line-clamp: 5
    -webkit-box-orient: vertical

.product-comments-card__block
  margin: 10px 0 0

.product-comments-card__block-title
  display: block
  font-size: 14px
  font-weight: 500

.product-comments-card__btn
  color: #3e77aa
  font-size: 14px
  background: transparent
  border-color: transparent
  padding: 0
  border-bottom: 1px dashed #3e77aa
  cursor: pointer
  margin-top: 20px
  display: inline-block

  &:hover
    border-color: transparent

  &:nth-child(2)
    margin-left: 30px

.product-comments-card__count-text
  font-size: 14px
  color: $placeholder-color
  margin-left: 30px

.product-comments-card--answer

  &:first-child
    padding: 0 0 30px

  .product-comments-card__comment-wrap
    margin-left: 60px

    &:before
      content: ''
      display: block
      position: absolute
      left: -40px
      height: 100%
      width: 1px
      background-color: #e7e7e7

.product-comments-card__from-set
  color: $placeholder-color
  font-size: 14px
  margin: 0 0 10px

.product-comments-card__photo-list
  +list-unstyled
  display: flex
  flex-flow: row nowrap

.product-comments-card__photo-item
  display: flex
  align-items: center
  width: 60px
  height: 60px
  cursor: pointer
  position: relative
  border-radius: 3px
  overflow: hidden
  margin-right: 15px

.product-comments-card__thumb-img
  display: block
  width: 100%
  height: 100%
  object-fit: cover

.play-video-btn
  width: 20px
  height: 20px

  &:before
    border-width: 3px 0 3px 5px

  &:hover
    background-color: $main-color

.video-item__img
  width: 60px
  height: 60px
  background-size: cover

</style>
